export default function (): boolean {
  const { $debug } = useNuxtApp();

  try {
    const { isRegulatoryValidationEnabled } = useUserData();
    const { userLimits } = useUserLimits();

    const shouldShowLimitsModule = computed<boolean>(() => {
      if (!isRegulatoryValidationEnabled.value) {
        return true;
      }

      return (
        userLimits.value?.user_limit_time_change !== null &&
        userLimits.value?.user_limit_loss_change !== null
      );
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ USER-LIMITS VALIDATION:\n');
      coloredDebug(shouldShowLimitsModule.value);
      console.groupEnd();
    }

    return shouldShowLimitsModule.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ USER-LIMITS VALIDATION:\n');
      console.error(err);
      coloredDebug(false);
      console.groupEnd();
    }

    return false;
  }
}
